import React from 'react'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import {Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import ProductHistoryOrganizationList from 'pages/ProductHistoryOrganization/ProductHistoryOrganizationList'
import ProductHistoryOrganizationDetail from 'pages/ProductHistoryOrganization/ProductHistoryOrganizationDetail'
import {AllUserRoles} from 'Authority'

export default function ProductPurchaseHistoryOrganizationRoute() {
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_PURCHASE_HISTORY_ORGANIZATION.path}
          exact
          component={ProductHistoryOrganizationList}
        />
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_PURCHASE_DETAIL_ORGANIZATION.path}
          exact
          component={ProductHistoryOrganizationDetail}
        />

        {/* <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route> */}
      </Switch>
    </CommonLayout>
  )
}
